import React, { lazy, Suspense } from 'react';
import { Platform } from 'react-native';
import { SiteMarkerProps } from './SiteMarker.native';

// Mirrors LazyMemoizedPantryMarker.js: import directly on web to avoid lazy-loading
// module-resolution issues; lazy-load on native for gradual marker load-in.
// eslint-disable-next-line import/extensions
const DirectSiteMarker = Platform.OS === 'web' ? require('./SiteMarker').default : null; // platform-specific: SiteMarker.native.tsx / SiteMarker.web.tsx

// eslint-disable-next-line import/extensions
const LazySiteMarker = Platform.OS !== 'web' ? lazy(() => import('./SiteMarker')) : null; // platform-specific: SiteMarker.native.tsx / SiteMarker.web.tsx

// Named export matches the convention already used by this task's sibling module, navigateToSiteDetails.ts.
// eslint-disable-next-line import/prefer-default-export
export function LazyMemoizedSiteMarker(props: SiteMarkerProps) {
  if (Platform.OS === 'web') {
    return <DirectSiteMarker {...props} />;
  }

  return (
    <Suspense>
      <LazySiteMarker {...props} />
    </Suspense>
  );
}
